module.exports = __webpack_public_path__ + "33d9dc24788424d719facb2fa5fe0d6f.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/share-slogan-6.png
// module id = 506
// module chunks = 0